import React, {useEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';
import './startSection.scss';
import Drawer from '@mui/material/Drawer';
import { STORE_LANGUAGE_KEY } from "../../../../components/utils/localization/i18n";

const StartSection = () => {
	const { t, i18n } = useTranslation();
	const { language } = i18n;
	const [isOpenBurger, setIsOpenBurger] = useState(false);

	const [width, setWidth]   = useState(window.innerWidth);

	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}

	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	useEffect(() => {
		const setLang = (lng: string) => {
			i18n.changeLanguage(lng).then(() => {
				document.documentElement.lang = lng;
			});
		};

		const storedLanguage = localStorage.getItem(STORE_LANGUAGE_KEY);

		if (storedLanguage) {
			setLang(storedLanguage);
		} else {
			setLang('no');
			changeLanguage('no');
		}
	}, [i18n]);

	const changeLanguage = (lng: string) => {
		i18n.changeLanguage(lng).then(() => {
			localStorage.setItem(STORE_LANGUAGE_KEY, lng);
			document.documentElement.lang = lng;
		});
	};

	const toggleDrawer = (newOpen: boolean) => () => {
		setIsOpenBurger(newOpen);
	};

	const scrollToBlock = (blockClass: string) => {
		setIsOpenBurger(false);
		const block = document.querySelector(`.${blockClass}`);
		if (block) {
			block.scrollIntoView({ behavior: 'smooth' });
		}
	};

	return (
		<div className="startSection">
			<div
				className="startSection__content"
				style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/StartImageBg.webp)` }}
			>
				<div className="startSection__content_header">
					{
						width > 767 ? (
							<div className="startSection__content_header_lng">
								<button
									onClick={() => changeLanguage('en')}
									className={language === 'en' ? 'active' : ''}
								>
									<span>{t('start.en')}</span>
								</button>
								<button
									onClick={() => changeLanguage('no')}
									className={language === 'no' ? 'active' : ''}
								>
									<span>{t('start.no')}</span>
								</button>
							</div>
						) : (
							<div className="startSection__content_header_burger">
								<button
									onClick={toggleDrawer(true)}
									className={"startSection__content_header_adaptive_burger"}
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="36"
										height="36"
										viewBox="0 0 36 36"
										fill="none"
									>
										<path
											d="M4.5 18H31.5M4.5 27H31.5M4.5 9H31.5"
											stroke="#EC6424"
											strokeWidth="2.25"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</button>
							</div>
						)
					}
					<Drawer className="header_drawer" open={isOpenBurger} onClose={toggleDrawer(false)}>
						<div className={`startSection__content_adaptive_data ${isOpenBurger ? 'active' : ''}`}>
							<div className="adaptive_close_btn">
								<button onClick={toggleDrawer(false)}>
									<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
										<path d="M1.83722 1.85991L31.557 31.537M31.5357 1.83856L1.85857 31.5584" stroke="#F37021" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
									</svg>
								</button>
							</div>
							<div className="adaptive_content">
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('gentleMegagrip')}
								>
									<span>{t('gentleMegagrip.title')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('advantages')}
								>
									<span>{t('advantages.title')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('collection')}
								>
									<span>{t('fourCollection.collections')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('sizes')}
								>
									<span>{t('sizes.title')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('reviews')}
								>
									<span>{t('freeTie.reviews')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('freeTie')}
								>
									<span>{t('freeTie.getYourFree')}</span>
								</button>

								<div className="adaptive_content_lng">
									<span>{t('start.language')}:</span>
									<div className="adaptive_content_lng_btns">
										<button
											onClick={() => changeLanguage('en')}
											className={language === 'en' ? 'active' : ''}
										>
											<span>{t('start.en')}</span>
										</button>
										<button
											onClick={() => changeLanguage('no')}
											className={language === 'no' ? 'active' : ''}
										>
											<span>{t('start.no')}</span>
										</button>
									</div>
								</div>
							</div>
							<div className="adaptive_footer">
								<div className="adaptive_footer_contacts">
							<span
								onClick={() => window.open('https://wa.me/+4721645447')}
							>
								+47 21 64 54 47
							</span>
									<span
										onClick={() => window.open('https://mail.google.com/mail/?view=cm&fs=1&to=post@kosiband.com')}
									>
								post@kosiband.com
							</span>
								</div>
								<div className="adaptive_footer_trademark">
									<p>Forhandlerportal:</p>
									<div className="adaptive_footer_contacts">
								<span
									onClick={() => window.open('https://www.hameltenpro.com')}
								>
									Hameltenpro.com
								</span>
									</div>
								</div>
							</div>
						</div>
					</Drawer>
					{/*<div className={`startSection__content_adaptive ${isOpenBurger ? 'active' : ''}`}>
						<div className={`startSection__content_adaptive_data ${isOpenBurger ? 'active' : ''}`}>
							<div className="adaptive_close_btn">
								<button onClick={() => setIsOpenBurger(false)}>
									<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
										<path d="M1.83722 1.85991L31.557 31.537M31.5357 1.83856L1.85857 31.5584" stroke="#F37021" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
									</svg>
								</button>
							</div>
							<div className="adaptive_content">
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('gentleMegagrip')}
								>
									<span>{t('gentleMegagrip.title')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('advantages')}
								>
									<span>{t('advantages.title')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('collection')}
								>
									<span>{t('fourCollection.title')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('sizes')}
								>
									<span>{t('sizes.title')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('reviews')}
								>
									<span>{t('freeTie.reviews')}</span>
								</button>
								<button
									className="adaptive_content_item"
									onClick={() => scrollToBlock('freeTie')}
								>
									<span>{t('freeTie.getYourFree')}</span>
								</button>

								<div className="adaptive_content_lng">
									<span>{t('start.language')}:</span>
									<div className="adaptive_content_lng_btns">
										<button
											onClick={() => changeLanguage('en')}
											className={language === 'en' ? 'active' : ''}
										>
											<span>{t('start.en')}</span>
										</button>
										<button
											onClick={() => changeLanguage('no')}
											className={language === 'no' ? 'active' : ''}
										>
											<span>{t('start.no')}</span>
										</button>
									</div>
								</div>
							</div>
							<div className="adaptive_footer">
								<div className="adaptive_footer_contacts">
							<span
								onClick={() => window.open('https://wa.me/+375333599739')}
							>
								+47 21 64 54 47
							</span>
									<span
										onClick={() => window.open('https://mail.google.com/mail/?view=cm&fs=1&to=post@kosiband.com')}
									>
								post@kosiband.com
							</span>
								</div>
								<div className="adaptive_footer_trademark">
									<p>Forhandlerportal:</p>
									<div className="adaptive_footer_contacts">
								<span
									onClick={() => window.open('https://www.hameltenpro.com')}
								>
									Hameltenpro.com
								</span>
									</div>
								</div>
							</div>
						</div>
					</div>*/}

					{/*<div className="img_glow"></div>*/}
					<img
						className={`mainLogo`}
						src={`${process.env.PUBLIC_URL}/assets/images/logo11.png`}
						alt={`Logo image`}
					/>
{/*
					<div className="img_glow-2"></div>
*/}
				</div>
				<div className="startSection__content_info">
					<div className={`startSection__content_info_text first ${language ? 'language' : '' }`}>
						<h2>{t('start.high')}</h2>
						<div className="text_glow"></div>
						<h2>{t('start.tech')}</h2>
						<div className="text_glow-2"></div>
					</div>
					{/*{
						language && language === 'no' ? (
							<div className={`startSection__content_info_text second no`}>
								<h1>{t('start.tie')}</h1>
							</div>
						) : (*/}
							<div className={`startSection__content_info_text second`}>
								<h1>{t('start.hair')}</h1>
								<h1>{t('start.tie')}</h1>
							</div>
						{/*)
					}*/}
				</div>
			</div>
		</div>
	);
};

export default StartSection;